import { View } from '@play-co/timestep-core/ui';
import StreakCloudRow, { StreakCloudVariant } from './StreakCloudRow';

type StreakCloudRowConfig = {
  variant: StreakCloudVariant;
  baseYRatio: number;
  scale?: number;
  speed?: number;
  opacity?: number;
  gap?: number;
  offset?: number;
  direction?: -1 | 1;
};

const cloudRowConfigs: StreakCloudRowConfig[] = [
  {
    variant: 'cloud2',
    baseYRatio: 0.67,
    speed: 0.15,
    offset: 100,
    opacity: 0.55,
  },
  {
    variant: 'cloud3',
    baseYRatio: 0.73,
    speed: 0.55,
    gap: 0,
    opacity: 0.75,
  },
];

export default class StreakClouds extends View {
  private cloudRows: StreakCloudRow[] = [];

  constructor(superview: View, width: number, height: number) {
    super({
      superview,
      width,
      height: height * 1.25,
      zIndex: -1,
    });

    for (let index = 0; index < cloudRowConfigs.length; index++) {
      const config = cloudRowConfigs[index];

      this.cloudRows.push(
        new StreakCloudRow({
          superview: this,
          variant: config.variant,
          width,
          gap: config.gap,
          imgScale: config.scale,
          speed: config.speed,
          direction: config.direction,
          opacity: config.opacity,
          offset: config.offset ?? 0,
          y: config.baseYRatio * this.style.height,
        }),
      );
    }
  }

  public tick() {
    this.cloudRows.forEach((row, index) => {
      const { baseYRatio } = cloudRowConfigs[index];
      const base = baseYRatio * this.style.height;
      row.style.y = base;
    });
  }
}
